<template >
  <v-list-item v-on="rowClickEnabled && item.rowClick ? { click: item.rowClick } : {}">
    <v-list-item-content >
      <v-list-item-title>
        <div class="d-flex flex-row">
          <div class="grow">{{title}}</div>
          <div>{{item.service.doneDate | date}}</div>
        </div>
      </v-list-item-title>
      <v-list-item-subtitle>
        <div class="d-flex flex-row">
          <div class="grow">{{target}}</div>
          <div>{{item.service.serviceState | serviceState}}</div>
        </div>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="showActions && !!item.rowActions && !!item.rowActions.length > 0">
      <entity-table-row-end-action-menu :actions="item.rowActions"/>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import EntityTableRowEndActionMenu from '@/components/entity-crud/EntityTableRowEndActionMenu';
export default {
  name: 'ServiceListItem',
  components: { EntityTableRowEndActionMenu },
  props:{
    item:{
      type: Object,
      required: true,
      validator: item => {
          return  !!item.service;
      },
    },
    showActions:{
      type: Boolean,
    },
    rowClickEnabled:{
      type: Boolean,
    },
  },
  computed:{

    title(){

      if (this.item.service.plannedServiceInstance){
        return this.item.service.plannedServiceInstance.name;
      }
      return this.item.service.defectReport.title;
    },

     target(){
      if (this.item.service.defectReport?.writeInDeviceName) {
        return this.item.service.defectReport.writeInDeviceName;
      }
      return this.$options.filters.device(this.item.service.device);
    },
  },
};
</script>

<style scoped>

</style>
